export default __webpack_public_path__ + "static/media/cw.420d655f.svg";